import { render, staticRenderFns } from "./sop.vue?vue&type=template&id=6560b6c0"
import script from "./sop.vue?vue&type=script&lang=js"
export * from "./sop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports